import React, { useState } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";

import CmtCard from "@coremat/CmtCard";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import { AddBox } from "@material-ui/icons";
import { Box, Button } from "@material-ui/core";
import KeyManagementListTable from "./KeyManagementTable";
import AddKeyDialog from "./AddKeyDialog";
import CmtSearch from "@coremat/CmtSearch";
import AssessmentIcon from "@material-ui/icons/Assessment";
import GetReportDialog from "./GetReportDialog";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    [theme.breakpoints.down("xs")]: {
      "& .Cmt-header-root": {
        flexDirection: "column",
      },
      "& .Cmt-action-default-menu": {
        marginLeft: 0,
        marginTop: 10,
      },
    },
  },
  cardContentRoot: {
    padding: 0,
  },
  actionsContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 20px",
  },
  buttonsContainer: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
  },
}));

const KeyManagementContainer = () => {
  const classes = useStyles();
  const [openAddKey, setOpenAddKey] = useState(false);
  const [openReportDialog, setOpenReportDialog] = useState(false);
  const [searchVal, setSearchVal] = useState("");

  return (
    <CmtCard className={classes.cardRoot}>
      <CmtCardContent className={classes.cardContentRoot}>
        <Box className={classes.actionsContainer}>
          <Box className={classes.buttonsContainer}>
            <Box>
              <CmtSearch
                border={false}
                onlyIcon={false}
                iconPosition="left"
                align="left"
                placeholder="جست و جو"
                value={searchVal}
                onChange={(e) => setSearchVal(e.target.value)}
              />
            </Box>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<AddBox />}
              onClick={() => setOpenAddKey(true)}
              style={{ marginRight: 14, marginBlock: "10px" }}
            >
              اضافه کردن کلید
            </Button>
          </Box>
          <Button
            variant="outlined"
            color="primary"
            startIcon={<AssessmentIcon />}
            onClick={() => setOpenReportDialog(true)}
            style={{ marginRight: 14 }}
          >
            دریافت گزارش
          </Button>
        </Box>
        <KeyManagementListTable
          searchMode={searchVal.trim().length > 0}
          searchInput={searchVal}
        />
      </CmtCardContent>
      <AddKeyDialog
        open={openAddKey}
        handleClose={() => setOpenAddKey(false)}
      />
      <GetReportDialog
        open={openReportDialog}
        handleClose={() => setOpenReportDialog(false)}
      />
    </CmtCard>
  );
};

export default KeyManagementContainer;
